module.exports = __webpack_public_path__ + "static/cad-designs11-6168190362df3710a7ec36d772f37273.png";